import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    req.headers.set('Access-Control-Allow-Origin', '*');
    req.headers.set('Access-Control-Allow-Credentials', 'true');
    req.headers.set('Access-Control-Allow-Methods','GET,POST,PUT,DELETE,OPTIONS,HEAD');
    req.headers.set('Access-Control-Allow-Headers','*' );
  

    var req1 = req.clone({
      headers: req.headers.set('TimeZone', this.GetTimeZone()),
    });
    return next.handle(req1).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        if (this.redirectToUnauthorizePage(error.error)) {
          this.redirectToUnauthorize(error.error)
        }
        return throwError(error);
      })
    );
  }

  redirectToUnauthorize(data: any) {
    if (this.redirectToUnauthorizePage(data)) {
      this.router.navigate(['/UnAuthorized/' + data]);
    }
  }

  redirectToUnauthorizePage(data: any) {
    if (data === 'Authorization has been denied for this request' || data.indexOf('Authorization has been denied') > -1 || data === 'Authorization has been denied because of Token Expiry' || 
      data ==='Authorization has been denied because of Token not exist') {
      return true
    } else {
      return false;
    }
  }

  public GetTimeZone() {
    let TimeZoneOptions = new Date().toString().match(/([-\+][0-9]+)\s/)[1].trim();
    if (!this.IsNullOrUndefined(TimeZoneOptions)) {
      return TimeZoneOptions;
    }
    return '';
  }
  public IsNullOrUndefined(iValue: any) {
    if (iValue == undefined || iValue == null) {
      return true;
    }
    else {
      return false;
    }
  }

}
